



















import {Component} from "vue-property-decorator"
import logger from "../../utils/logging"
import router from "../../router"
import BaseVue from "../../utils/BaseVue"

@Component
export default class LoginForm extends BaseVue {
    private async onSubmitClicked() {
        router.replace("/")
    }
}
